var exports = {
  "kL": "AttachmentFile.module__container___RlgxLW",
  "G5": "AttachmentFile.module__deleteButton___RlgxLW",
  "Dq": "AttachmentFile.module__attachmentContainer___RlgxLW",
  "zc": "AttachmentFile.module__iconContainer___RlgxLW",
  "el": "AttachmentFile.module__fileInfoContainer___RlgxLW",
  "Md": "AttachmentFile.module__fileName___RlgxLW",
  "m$": "AttachmentFile.module__fileNameTruncate___RlgxLW",
  "i_": "AttachmentFile.module__fileExtension___RlgxLW",
  "Ov": "AttachmentFile.module__fileSize___RlgxLW",
  "l6": "AttachmentFile.module__downloadButton___RlgxLW",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___RlgxLW",
};

module.exports = exports;
